import gerrieLoadSlangListAPIHandler from "@bToC/Handlers/ProductSlangListHandler";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        accountSettings: getSettingsCollection(state).accountSettings,
    };
};

const mapDispatchToProps = {
    gerrieLoadSlangListAPIHandler,
};

type Props = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface DisplayProductSlangTermListStyles {
    container: TypographyProps;
    boldText?: TypographyProps;
    normalText?: TypographyProps;
}

export const displayProductSlangTermListStyles: DisplayProductSlangTermListStyles = {
    container: {
        css: css`
        padding: 14px 0px 12px;
        border-bottom: 2px solid ${getColor("text.main")};
        `
    },
    boldText: {
        css: css`
        font-weight: bold;
        `
    },
    normalText: {
        css: css`
        font-weight: normal;
        `
    }
};

const styles = displayProductSlangTermListStyles;

const DisplayProductSlangTermList = ({
    gerrieLoadSlangListAPIHandler,
    productContext,
}: Props) => {
    const [data, setData] = React.useState("");
    const [show, setShow] = React.useState(true);

    const noSlangTermText = siteMessage("ProductDetails_NoSlangTerms") as any;

    const productNumber = productContext.productInfo.productId;

    const showNoSlangTerm = () => {
        setData(noSlangTermText);
        setShow(false);
    }

    React.useEffect(() => {
        gerrieLoadSlangListAPIHandler({ 
            productId: productNumber,
            onComplete: (resultProps: any) => {
                if(!resultProps.apiResult || resultProps.apiResult.length === 0){
                    showNoSlangTerm();
                } else {
                    setData(resultProps.apiResult.join(','));
                }
            }
         });
    }, []);

    return (
        <Typography {...styles.container} as="div">
            {show && <Typography {...styles.boldText}>{translate("Known As:")}&nbsp;</Typography>}
            <Typography {...(show ? styles.normalText : styles.boldText)}>{data}</Typography>
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProductContext(DisplayProductSlangTermList)),
    definition: {
        displayName: "Display Slang List",
        group: "Product Details",
    },
};

export default widgetModule;
